import React, { useEffect, useState } from 'react'

import { Box, Divider } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import { Card } from 'components'
import {
  FragilitiesSection,
  ObservationSection,
  PlanActionsSection,
  RiskLevelSection,
} from './components'

import useSnackbar from 'hooks/useSnackbar'
import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import { routes } from 'Routes'
import helpers from 'helpers'
import * as service from 'service'

const RisksStep = () => {
  const [hasDraftPlanAction, setHasDraftPlanAction] = useState(false)

  const { handleSubmit } = useFormContext()
  const {
    wantsToAdvanceStep,
    resetAdvanceStep,
    setIsLoading,
    companySupplierId,
    isEdit,
    isShow,
    isPreAvaliation,
    fromCreate,
  } = useThirdPartyManagementStepper()
  const snackbar = useSnackbar()
  const history = useHistory()

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      await service.dponet.suppliers.risks({
        companySupplierId,
        ...data,
      })

      if (isEdit) {
        snackbar.open({
          message: 'Etapa de Riscos atualizada com sucesso',
          variant: 'success',
        })
      }

      resetAdvanceStep()
      history.push(
        isPreAvaliation
          ? routes.thirdPartyManagements.preAvaliations
          : routes.thirdPartyManagements.mySuppliers.all,
      )
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao criar fornecedor',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!wantsToAdvanceStep || isShow) return

    if (hasDraftPlanAction) {
      snackbar.open({
        message:
          'Salve ou remova o plano de ação em rascunho antes de finalizar.',
        variant: 'error',
      })
      return resetAdvanceStep()
    }

    let validationPassed = false

    // Para não travar o formulário se der erro de validação do yup
    handleSubmit((data) => {
      validationPassed = true
      return onSubmit(data)
    })().then(() => {
      if (!validationPassed) resetAdvanceStep()
    })
  }, [wantsToAdvanceStep])

  return (
    <Box display="flex" flexDirection="column" gridGap={12}>
      <Card title="Nível de Risco e Ameaças">
        <Box display="flex" flexDirection="column" gridGap={24}>
          <RiskLevelSection />
          <Divider />
          <FragilitiesSection />
        </Box>
      </Card>
      <ObservationSection />
      {!fromCreate && (
        <PlanActionsSection setHasDraftPlanAction={setHasDraftPlanAction} />
      )}
    </Box>
  )
}

export default RisksStep
